function cov_2hpxipl91t() {
  var path = "/app/src/components/snippet-wrapper/snippet-wrapper.tsx";
  var hash = "183d3a21994a52e28831dd7eae1594239251ffbf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/snippet-wrapper/snippet-wrapper.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 16,
          column: 35
        }
      },
      "1": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 41,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "SnippetWrapper",
        decl: {
          start: {
            line: 9,
            column: 16
          },
          end: {
            line: 9,
            column: 30
          }
        },
        loc: {
          start: {
            line: 15,
            column: 24
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 32
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 13,
            column: 28
          },
          end: {
            line: 13,
            column: 32
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 23
          },
          end: {
            line: 14,
            column: 27
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 13
          },
          end: {
            line: 24,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 24,
            column: 21
          },
          end: {
            line: 24,
            column: 26
          }
        }, {
          start: {
            line: 24,
            column: 29
          },
          end: {
            line: 24,
            column: 34
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 12
          },
          end: {
            line: 32,
            column: 20
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 31,
            column: 16
          },
          end: {
            line: 31,
            column: 51
          }
        }, {
          start: {
            line: 32,
            column: 16
          },
          end: {
            line: 32,
            column: 20
          }
        }],
        line: 30
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "183d3a21994a52e28831dd7eae1594239251ffbf"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hpxipl91t = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2hpxipl91t();
import cn from 'classnames';
import React from 'react';
import { useAppContext } from 'src/context/store/app-provider';
import { ShadowView } from '../shadow-view';
import styles from './styles.css';
export function SnippetWrapper(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children,
    className = _ref.className,
    _ref$shouldInheritFon = _ref.shouldInheritFontFamily,
    shouldInheritFontFamily = _ref$shouldInheritFon === void 0 ? (cov_2hpxipl91t().b[0][0]++, true) : _ref$shouldInheritFon,
    _ref$shouldInheritCol = _ref.shouldInheritColor,
    shouldInheritColor = _ref$shouldInheritCol === void 0 ? (cov_2hpxipl91t().b[1][0]++, true) : _ref$shouldInheritCol;
  cov_2hpxipl91t().f[0]++;
  var _ref2 = (cov_2hpxipl91t().s[0]++, useAppContext()),
    isRtl = _ref2.isRtl;
  cov_2hpxipl91t().s[1]++;
  return /*#__PURE__*/React.createElement(ShadowView, {
    shouldInheritFontFamily: shouldInheritFontFamily,
    shouldInheritColor: shouldInheritColor
  }, /*#__PURE__*/React.createElement("div", {
    dir: isRtl ? (cov_2hpxipl91t().b[2][0]++, 'rtl') : (cov_2hpxipl91t().b[2][1]++, 'ltr'),
    className: styles.snippetWrapperContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.tabbyPromoSnippet, shouldInheritFontFamily ? (cov_2hpxipl91t().b[3][0]++, styles.tabbyPromoSnippetFontInherit) : (cov_2hpxipl91t().b[3][1]++, null), className),
    onClick: onClick
  }, children)));
}